import { Module } from 'vuex';
import { MessagesState } from './types';
import createMessagesState from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const messages: Module<MessagesState, any> = {
  namespaced: true,
  state: () => createMessagesState(),
  mutations,
  actions,
  getters,
};

export default messages;

export { default as createMessagesState } from './state';
export type { MessagesState } from './types';
